import request from 'src/lib/data/request'

export default async function graphMany(req, pairs, ctx = {}) {
  const payload = {
    pairs
  }

  const res = await request(req, ctx).post('/graphMany2').send(payload)
  return res.body
}
